export default function Logo({ className = "h-9" }) {
  return (
    <svg
      viewBox="0 0 250 56"
      className={`${className} w-auto`}
      role="img"
      aria-label="DM Levantamentos Topográficos"
    >
      <defs>
        <linearGradient id="dmSwoosh" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#0062ff" />
          <stop offset="0.55" stopColor="#38bdf8" />
          <stop offset="1" stopColor="#00f0ff" />
        </linearGradient>
      </defs>
      <path
        d="M4 42 C 70 50, 170 50, 246 28"
        stroke="url(#dmSwoosh)"
        strokeWidth="4"
        fill="none"
        strokeLinecap="round"
      />
      <text
        x="4"
        y="34"
        fontFamily="Outfit, sans-serif"
        fontWeight="900"
        fontSize="38"
        fill="#f8fafc"
        letterSpacing="-2"
      >
        DM
      </text>
      <text
        x="98"
        y="22"
        fontFamily="Outfit, sans-serif"
        fontWeight="600"
        fontSize="13.5"
        fill="#e2e8f0"
        letterSpacing="2.2"
      >
        LEVANTAMENTOS
      </text>
      <text
        x="98"
        y="41"
        fontFamily="Outfit, sans-serif"
        fontWeight="600"
        fontSize="13.5"
        fill="#38bdf8"
        letterSpacing="2.2"
      >
        TOPOGRÁFICOS
      </text>
    </svg>
  );
}
